import React from 'react';
import { withProps, componentFromProp } from 'recompose';
import * as components from './components';

export default withProps<any, any>(
  ({ type }) => ({ fieldComponent: components[type] })
)(componentFromProp('fieldComponent'))
